import React from 'react';
import { useContactsData } from 'hooks/useContactsData';
import ErrorLayout from 'layouts/ErrorLayout';
import LoadingLayout from 'layouts/LoadingLayout';
import { IContact } from 'pages/About/About.types';

import { Box, Link } from '@mui/material';

export default function Contacts() {
  const { data, error, loading } = useContactsData();

  return (
    <Box sx={styles.container}>
      <LoadingLayout loading={loading} style={{ my: 0 }}>
        <ErrorLayout data={data} error={error}>
          <Box>
            {data
              ? data.contacts.map((contact: IContact) => (
                  <Link
                    sx={styles.link}
                    key={contact.icon}
                    href={contact.url}
                    rel='noopener noreferrer'
                    target={contact.name !== 'Email' ? '_blank' : '_self'}
                  >
                    <i className={contact.icon}></i>
                  </Link>
                ))
              : null}
          </Box>
        </ErrorLayout>
      </LoadingLayout>
    </Box>
  );
}

const styles = {
  container: {
    my: 3,
  },
  link: { fontSize: '27px', m: 0.4, p: 0.4 },
};
